var firebaseConfig = {
    apiKey: "AIzaSyCT2Abebb_aLOxM5-E0YCr1aEy8IQuae9Y",
    authDomain: "rapid-riders-63b08.firebaseapp.com",
    projectId: "rapid-riders-63b08",
    storageBucket: "rapid-riders-63b08.appspot.com",
    messagingSenderId: "673776543301",
    appId: "1:673776543301:web:d70e98ccac76f59a1c652c"
  };

  export default firebaseConfig;